import { z } from 'zod';

/**
 * Schemas mirror docs/api/auth/*.md exactly. Drift here means the docs
 * or the backend changed underneath us — fail loudly.
 */

const isoDate = z.string().min(1);
const uuid = z.string().min(1);
const jwt = z.string().min(1);

export const loginRequestSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});
export type LoginRequest = z.infer<typeof loginRequestSchema>;

export const loginSuccessSchema = z.object({
  access_token: jwt,
  refresh_token: z.string().min(1),
  expires_at: isoDate,
  user_id: uuid,
});
export const loginMfaRequiredSchema = z.object({
  access_token: jwt,
  expires_at: isoDate,
  user_id: uuid,
  mfa_required: z.literal(true),
});
export const loginResponseSchema = z.union([loginMfaRequiredSchema, loginSuccessSchema]);
export type LoginResponse = z.infer<typeof loginResponseSchema>;

export const mfaChallengeRequestSchema = z.object({
  code: z.string().regex(/^\d{6}$/u),
});
export type MfaChallengeRequest = z.infer<typeof mfaChallengeRequestSchema>;

export const mfaChallengeResponseSchema = loginSuccessSchema;
export type MfaChallengeResponse = z.infer<typeof mfaChallengeResponseSchema>;

export const refreshRequestSchema = z.object({
  refresh_token: z.string().min(1),
});
export const refreshResponseSchema = loginSuccessSchema;
export type RefreshResponse = z.infer<typeof refreshResponseSchema>;

export const forgotPasswordRequestSchema = z.object({
  email: z.string().email(),
});

export const resetPasswordRequestSchema = z.object({
  token: z.string().min(1),
  new_password: z.string().min(10).max(200),
});

export const verifyEmailResponseSchema = z.object({
  status: z.literal('ok'),
});
